<template>
  <div class="labelTemplate">
    <div class="header">
      <el-tabs :value="tabPaneValue" @tab-click="tabPaneClick">
        <el-tab-pane label="标签模板" name="first">
          <span
            class="childTabs"
            :class="{activeLink: printLink=='firstLink'}"
            @click="printClick('firstLink')"
          >标签模版</span>
          <div class="childTabsBox">
            <span
              v-for="(item, index) in printList"
              :key="item.id"
              @click="printClick(item.id)"
              :class="{activeLink: printLink==item.id}"
              class="childTabs"
            >
              {{item.name}}
              <i class="el-icon-circle-close" @click.stop="closePrintTabs(index)"></i>
            </span>
          </div>
          <div class="btnBox" v-if="printLink == 'firstLink'">
            <div class="searchBtnBox" style="margin-right:15px">
              <el-tooltip class="item" content="只看我创建的标签" placement="bottom" :open-delay="300">
                <el-checkbox v-model="searchConditionForm.onlyMy" @change="onlyMyChange">我的标签</el-checkbox>
              </el-tooltip>
            </div>
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip class="item" content="清除查询条件" placement="bottom" :open-delay="300">
                <el-button icon="iconfont icon-qingkong" size="small"
                  class="cleanBox" @click="onClear"></el-button>
              </el-tooltip>
              <el-button type="primary" size="small" @click="onSearch">查询</el-button>
            </div>
            <el-button type="primary" icon="el-icon-plus" size="small" @click="addNewBtn">新建</el-button>
            <el-tooltip class="item" content="查询条件" placement="bottom" :open-delay="300">
              <el-button
                class="btn_more"
                :class="{activeUserMore:isMoreSearch}"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
          <div class="btnBox" v-else>
            <el-button class="roll_back_btn" icon="el-icon-refresh-left" size="small" @click="rollbackLabelTemplateBtn">恢复上一次</el-button>
            <el-button
              type="primary"
              icon="el-icon-document-copy"
              size="small"
              @click="copyLabelTemplateBtn"
            >复制</el-button>
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="small"
              @click="editLabelTemplateBtn"
            >修改</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="字体和工具" name="fontManage">
          <span class="activeLink">字体和工具</span>
          <div class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip class="item" content="清除查询条件" placement="bottom" :open-delay="300">
                <el-button icon="iconfont icon-qingkong" size="small"
                  class="cleanBox" @click="onClear"></el-button>
              </el-tooltip>
              <el-button type="primary" size="small" @click="onSearch">查询</el-button>
            </div>
            <el-button type="primary" icon="el-icon-plus" size="small" @click="addFontBtn">新建</el-button>
            <el-tooltip class="item" content="查询条件" placement="bottom" :open-delay="300">
              <el-button
                class="btn_more"
                :class="{activeUserMore:isMoreSearch}"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-form
        :inline="true"
        :model="searchConditionForm"
        class="demo-form-inline"
        v-if="isMoreSearch && tabPaneValue == 'first' && printLink == 'firstLink'"
      >
        <div class="searchConditionBox">
          <el-form-item label="模板名称" size="small">
            <el-input v-model="searchConditionForm.name" placeholder="如：966G2机身（奥尼）" clearable
              @keyup.enter.native="getLabelTemplateSearch()"></el-input>
          </el-form-item>
          <el-form-item label="成品编码" size="small">
            <el-input v-model="searchConditionForm.itemCode" placeholder="输入成品编码" clearable
              @keyup.enter.native="getLabelTemplateSearch()"></el-input>
          </el-form-item>
          <el-form-item label="客户" size="small">
            <el-select
              v-model="searchConditionForm.customerId"
              placeholder="选择客户"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标签类型" size="small">
            <el-select
              v-model="searchConditionForm.labelType"
              placeholder="选择标签类型"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.labelTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="打印机" size="small">
            <el-select
              v-model="searchConditionForm.printerType"
              placeholder="选择打印机型号"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.printerTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品类别" size="small">
            <el-select
              v-model="searchConditionForm.productType"
              placeholder="选择产品类别"
              filterable
              clearable
              @change="productTypeChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.productTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品型号" size="small">
            <el-select
              v-model="searchConditionForm.productId"
              placeholder="选择产品型号"
              filterable
              clearable
              :disabled="!searchConditionForm.productType"
            >
              <el-option
                v-for="(item, index) in pullDownData.productList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <el-form
        :inline="true"
        :model="fontSearchForm"
        class="demo-form-inline"
        v-else-if="isMoreSearch && tabPaneValue == 'fontManage'"
      >
        <div class="searchConditionBox">
          <el-form-item label="名称" size="small">
            <el-input v-model="fontSearchForm.name" placeholder="输入字体或工具名称" clearable
              @keyup.enter.native="$refs.fontManage.getFontSearch()"></el-input>              
            <el-input v-show="false"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="tips tipsBox" v-show="tabPaneValue == 'fontManage' && isShowTips">
        <span class="title">温馨提示：</span>
        <span class="text">“微软雅黑”和方正字体系列请务必慎用！小心侵权！</span>
        <span class="more text" @click="tipsClick">更多>></span>
        <i class="el-icon-close close" @click="closeTips"></i>
      </div>
    </div>
    <div class="contentBox">
      <div class="rightContent" v-if="tabPaneValue == 'first' && printLink == 'firstLink'">
        <el-table
          stripe
          :data="tableData"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          @sort-change="sortChange"
        >
          <el-table-column
            type="index"
            :width="pagination.endIndex >= 1000 ? 80:50"
            align="center"
            :index="pagination.beginIndex"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="模板名称"
            min-width="130"
            align="center"
            show-overflow-tooltip
            sortable="custom"
          >
            <template slot-scope="scope">
              <span class="allowSkip" @click="clickAllowSkip(scope.row)">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="itemCode" label="成品编码" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.itemCode">{{scope.row.itemCode}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="customerId"
            label="客户"
            align="center"
            min-width="110"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.customer">{{scope.row.customer.name}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="productId"
            label="产品型号"
            align="center"
            min-width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.product">{{scope.row.product.name}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="labelType" label="标签类型" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.labelType">{{scope.row.labelType.title}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="printerType" label="打印机" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.printerType">{{scope.row.printerType.title}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="inQuantity" label="包装规格" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.inQuantity">{{scope.row.inQuantity}} in One</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="width" label="标签宽(W)" width="100" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.width">{{scope.row.width}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="height" label="标签高(H)" width="100" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.height">{{scope.row.height}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
      <el-table-column
        class-name="operation"
        label="操作"
        align="center" width="95px"
      >
        <template slot-scope="scope">          
          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="deleteTemplate($event, scope.row)"
              class="el-icon-delete"
            ></i>
          </el-tooltip>          
        </template>
      </el-table-column>
        </el-table>
        <pagination
          :pagination="pagination"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
          @refreshBtn="getLabelTemplateSearch"
        ></pagination>
      </div>
      <div class="rightContent" v-else-if="tabPaneValue == 'first' && printLink != 'firstLink'">
        <detailPage ref="detailPage" :printLink="printLink"></detailPage>
      </div>
      <div class="rightContent" v-else>
        <fontManage ref="fontManage" :fontSearchForm="fontSearchForm"></fontManage>
      </div>
    </div>
    <myDialog
      ref="myDialog"
      :title="dialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="700px"
      top="2vh"
      class="scrollDialog"
    >
      <template slot="content">
        <div class="tips">
          <span class="title">温馨提示：</span>600点打印机 1点≈25.4mm/600≈0.042mm；300点打印机 1点≈25.4mm/300≈0.085mm；
          203点打印机 1点≈25.4mm/203≈0.125mm。
        </div>
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
          class="scrollForm"
        >
          <el-form-item label="模板名称" size="small" prop="name" class="inlineItem">
            <el-input v-model="dialogForm.name" placeholder="如：966G2机身（奥尼）" clearable></el-input>
          </el-form-item>
          <el-form-item label="客户" size="small" prop="customerId" class="inlineItem">
            <el-select v-model="dialogForm.customerId" placeholder="选择客户" filterable clearable>
              <el-option
                v-for="(item, index) in pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品类别" size="small" prop="productType" class="inlineItem">
            <el-select
              v-model="dialogForm.productType"
              placeholder="选择产品类别"
              filterable
              clearable
              @change="addProductTypeChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.productTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品型号" size="small" prop="productId" class="inlineItem">
            <el-select v-model="dialogForm.productId" placeholder="选择产品型号" filterable clearable>
              <el-option
                v-for="(item, index) in pullDownData.productList2"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="成品编码" size="small" prop="itemCode" class="inlineItem">
            <el-input v-model="dialogForm.itemCode" placeholder="输入成品编码" clearable></el-input>
          </el-form-item>
          <el-form-item label="包装规格" size="small" prop="inQuantity" class="inlineItem">
            <el-input
              v-model="dialogForm.inQuantity"
              placeholder="标签内含裸机的数量"
              clearable
              @input="formatInt($event, 'dialogForm', 'inQuantity')"
            ></el-input>
          </el-form-item>
          <el-form-item label="标签类型" size="small" prop="labelType" class="inlineItem">
            <el-select v-model="dialogForm.labelType" placeholder="选择标签类型" filterable clearable>
              <el-option
                v-for="(item, index) in pullDownData.labelTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="打印机" size="small" prop="printerType" class="inlineItem">
            <el-select v-model="dialogForm.printerType" placeholder="选择打印机型号" filterable clearable>
              <el-option
                v-for="(item, index) in pullDownData.printerTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="dialogForm.printerType && !(dialogForm.printerType=='NETC' || dialogForm.printerType=='BarTender' || dialogForm.printerType=='CodeSoft')" label="标签宽(W)" size="small" prop="width" class="inlineItem">
            <el-input
              v-model="dialogForm.width"
              placeholder="标签纸宽度，如：118"
              clearable
              @input="formatInt($event, 'dialogForm', 'width')"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="dialogForm.printerType && !(dialogForm.printerType=='NETC' || dialogForm.printerType=='BarTender' || dialogForm.printerType=='CodeSoft')" label="标签高(H)" size="small" prop="height" class="inlineItem">
            <el-input
              v-model="dialogForm.height"
              placeholder="标签纸高度，如：118"
              clearable
              @input="formatInt($event, 'dialogForm', 'height')"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="dialogForm.printerType && dialogForm.printerType=='NETC'" label="镭雕模版" prop="fileUpload" size="small">
            <div class="right">
              <span :title="dialogForm.netcLabelName" class="allowSkip" @click="downloadFile(dialogForm.netcFid, '镭雕模版')">{{dialogForm.netcLabelName}}</span>
            </div>
            <input v-model="dialogForm.netcFid" type="hidden"/>
            <input ref="fileUpload" class="fileUpload" type="file"
              @change="fileChange('fileUpload')"
            />
          </el-form-item>
          <el-form-item v-else-if="dialogForm.printerType && dialogForm.printerType=='BarTender'" label="标签模版" prop="fileUpload" size="small">
            <div class="right">
              <span :title="dialogForm.barTenderLabelName" class="allowSkip" @click="downloadFile(dialogForm.netcFid, 'BarTender模版')">{{dialogForm.barTenderLabelName}}</span>
            </div>
            <input v-model="dialogForm.netcFid" type="hidden"/>
            <input ref="fileUpload" class="fileUpload" type="file"
              @change="fileChange('fileUpload')"
            />
          </el-form-item>
          <el-form-item v-else-if="dialogForm.printerType && dialogForm.printerType=='CodeSoft'" label="标签模版" prop="fileUpload" size="small">
            <div class="right">
              <span :title="dialogForm.barTenderLabelName" class="allowSkip" @click="downloadFile(dialogForm.netcFid, 'CodeSoft模版')">{{dialogForm.barTenderLabelName}}</span>
            </div>
            <input v-model="dialogForm.netcFid" type="hidden"/>
            <input ref="fileUpload" class="fileUpload" type="file"
              @change="fileChange('fileUpload')"
            />
          </el-form-item>
          <el-form-item v-else-if="dialogForm.printerType" label="打印机指令" prop="commands" size="small">
            <el-input
              type="textarea"
              :autosize="{minRows: 10}"
              placeholder="暂只支持博思得PPLE和斑马ZPL指令集"
              v-model="dialogForm.commands"
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import detailPage from "./components/detailPage.vue";
import fontManage from "./components/fontManage.vue";
import {
  apiLabelTemplateSearch,
  apiLabelTemplateAdd,
  apiLabelTemplateUpdate,
  apiLabelTemplateDelete,
  apiProductTypeList,
  apiProductList,
  apiCustomerList,
  apiLabelTypeList,
  apiPrinterTypeList
} from "@/api/labelTemplate.js";
import { apiUploadFile, apiDownloadFile } from "@/api/filesUpload.js";
export default {
  lastModuleConfig: { modulePath: "/homePage/labelTemplate", topTabVar: "tabPaneValue", topTabs: ["first", "fontManage"] },
  components: {
    pagination,
    myDialog,
    detailPage,
    fontManage
  },
  data() {
    return {
      tabPaneValue: "first",
      printLink: "firstLink",
      printList: [],
      isMoreSearch: false,
      searchConditionForm: {},
      fontSearchForm: {},
      isTipsShow: true,
      pullDownData: {
        productTypeList: [],
        productList: [],
        productList2: [],
        labelTypeList: [],
        customerList: [],
        printerTypeList: []
      },
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10
      },
      dialogTitle: "",
      dialogForm: {
      },
      dialogRules: {
        name: [
          { required: true, message: "模板名称不能为空！", trigger: "blur" },
          {
            min: 4,
            max: 64,
            message: "长度在 4 到 64 个字符",
            trigger: "change"
          }
        ],
        customerId: [
          { required: true, message: "客户不能为空！", trigger: "change" }
        ],
        productType: [
          { required: true, message: "产品类别不能为空！", trigger: "change" }
        ],
        productId: [
          { required: true, message: "产品型号不能为空！", trigger: "change" }
        ],
        itemCode: [
          { required: true, message: "成品编码不能为空！", trigger: "change" }
        ],
        labelType: [
          { required: true, message: "标签类型不能为空！", trigger: "change" }
        ],
        printerType: [
          { required: true, message: "打印机型号不能为空！", trigger: "change" }
        ],
        width: [
          { required: true, message: "标签纸宽度不能为空！", trigger: "change" }
        ],
        height: [
          { required: true, message: "标签纸高度不能为空！", trigger: "change" }
        ],
        inQuantity: [
          { required: true, message: "包装规格不能为空！", trigger: "change" }
        ],
        commands: [
          { required: true, message: "打印机指令不能为空！", trigger: "change" }
        ]
      },
      labelWidth: this.$store.state.labelWidth,
      isShowTips: true
    };
  },
  watch: {
    tabPaneValue: function(newVal) {
      this.$moreSearchStyle();
      if (newVal == "first") {
        if (this.printLink == "firstLink") {
          this.getLabelTemplateSearch();
        } else {
          this.$nextTick(() => {
            this.$refs.detailPage.getLabelTemplateDetail();
          });
        }
      } else {
        this.$nextTick(() => {
          this.$refs.fontManage.getFontSearch();
        });
      }
    },
    printLink: function(newVal) {
      this.$moreSearchStyle();
      if (newVal == "firstLink") {
        this.getLabelTemplateSearch();
      } else {
        this.$nextTick(() => {
          this.$refs.detailPage.getLabelTemplateDetail();
        });
      }
    }
  },
  methods: {
    downloadFile(fid, fileName, secretKey) {
      let a = document.createElement("a");
      a.download = fileName + "下载";
      a.href = apiDownloadFile(fid, secretKey);
      a.style.display = "none";
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    // 文件上传
    async fileChange(refName) {
      this.$set(this.dialogForm, "fileUpload", this.$refs[refName].files[0]);
      this.$refs.dialogForm.validateField("fileUpload");
      // console.log(file)
    },
    // 切换一级面板
    tabPaneClick(tab) {
      this.tabPaneValue = tab.name;
    },
    // 切换标签模版子面板
    printClick(value) {
      this.printLink = value;
    },
    // 关闭标签模版子面板
    closePrintTabs(index) {
      if (this.printList[index].id == this.printLink) {
        if (index > 0) {
          this.printLink = this.printList[index - 1].id;
        } else {
          this.printLink = "firstLink";
        }
      }
      this.printList.splice(index, 1);
    },
    // 表格数据
    async getLabelTemplateSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiLabelTemplateSearch({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    // 新建标签模版
    addNewBtn() {
      this.dialogTitle = "新建模板";
      this.$refs.myDialog.dialogVisible = true;
      this.$set(this.dialogForm, "inQuantity", 1);
    },
    // 新建字体
    addFontBtn() {
      this.$refs.fontManage.addFontBtn();
    },
    // 温馨提示
    tipsClick() {
      if (this.isTipsShow) {
        const h = this.$createElement;
        this.$notify({
          // title: '提示',
          message: h("div", null, [
            h("p", { style:"text-indent:2em" }, "“微软雅黑”字体是“北大方正电子有限公司”设计开发的字体作品。该字体与著名的“方正兰亭黑系列字体”（该系列字体共有十一个不同粗细版本，共十一款字体）系出同源，前者针对屏幕显示，后者针对印刷用。"),
            h("p", { style:"text-indent:2em" }, "方正公司拥有“方正兰亭黑系列字体”的全部版权。但微软雅黑的版权分为两个部分，在Windows系统的内嵌使用，包括屏幕输出和个人使用为目的的打印，这部分微软已经向方正支付了版权授权费用，所有正版Windows用户均可放心使用。但是以商业发布为目的的微软雅黑版权，仍由北大方正保留。"),
            h("p", { style:"text-indent:2em" }, "另外方正也有可用于商业的12款字体：方正仿宋繁體、方正仿宋简体、方正仿宋GBK、方正书宋GBK、方正黑体GBK、方正楷体GBK、方正黑體繁體、方正楷體繁體、方正楷体简体、方正书宋简体、方正黑体简体。其它方正或其它未知版权的字体严禁使用！"),
            h(
              "p",
              { style: "color:var(--themeColor);cursor:pointer;text-indent:2em", class: "tipsLink" },
              "分享5大类，23款不落俗套.pdf"
            )
          ]),
          onClose: () => {
            document.querySelector(".tipsLink").onclick = null;
            this.isTipsShow = true;
          }
        });
        this.$nextTick(() => {
          document.querySelector(".tipsLink").onclick = () => {
            this.$refs.fontManage.fontFileClick({
              file: {
                id: "24728385803653120",
                name: "分享5大类，23款不落俗套.pdf"
              }
            });
          };
        });
        this.isTipsShow = false;
      }
    },
    // 关闭温馨提示
    closeTips() {
      this.isShowTips = false;
      this.$moreSearchStyle();
    },
    deleteTemplate(e, row) {
      e.target.blur();
      this.$allOperation({ name: row.name }, "删除", "标签模版").then(
        async () => {
          const res = await apiLabelTemplateDelete({
            id: row.id,
          });
          if (res.code == 0) {
            this.getLabelTemplateSearch();                
            this.$message({
              message: "删除成功",
              type: "success",
            });
          }
        }
      );
    },
    // 还原模板
    rollbackLabelTemplateBtn() {
      this.$refs.detailPage.rollbackLabelTemplateBtn();
    },
    // 复制模板
    copyLabelTemplateBtn() {
      this.dialogTitle = "复制模板";
      let detailData = this.$refs.detailPage.labelTemplateDetailData;
      this.dialogForm = {
        ...detailData,
        name: detailData.name + "Copy",
        customerId: detailData.customer.id,
        direction: detailData.direction.code,
        labelType: detailData.labelType.code,
        printerType: detailData.printerType.code,
        productType: detailData.productType.code,
        productId: detailData.product.id,
        id: undefined,
        customer: undefined,
        product: undefined
      };
      this.getProductList(detailData.productType.code, "productList2");
      this.$refs.myDialog.dialogVisible = true;
    },
    // 修改模板
    editLabelTemplateBtn() {
      this.dialogTitle = "修改模板";
      let detailData = this.$refs.detailPage.labelTemplateDetailData;
      this.dialogForm = {
        ...detailData,
        customerId: detailData.customer.id,
        direction: detailData.direction.code,
        labelType: detailData.labelType.code,
        printerType: detailData.printerType.code,
        productType: detailData.productType.code,
        productId: detailData.product.id,
        customer: undefined,
        product: undefined
      };
      this.getProductList(detailData.productType.code, "productList2");
      this.$refs.myDialog.dialogVisible = true;
    },
    // 新建-产品类别改变
    addProductTypeChange(value) {
      this.$set(this.dialogForm, "productId", undefined);
      this.pullDownData.productList2 = [];
      if (value) {
        this.getProductList(value, "productList2");
      }
    },
    // 新建-格式化数值为正整数
    formatInt(value, formName, name) {
      let newValue = value.replace(/[^\d]/g, "");
      if (newValue <= 0) {
        newValue = 0;
      }
      this.$set(this[formName], name, newValue);
    },
    // 确认新建
    submitData(title) {
      this.$refs.dialogForm.validate(async valid => {
        if (valid) {
          let res = {};
          // 上传模版
          if (this.dialogForm.fileUpload) {
            let fd = new FormData();          
            fd.append("file", this.dialogForm.fileUpload);
            fd.append("secret", false);
            res = await apiUploadFile(fd);
            if (res.code == 0) {
              if (this.dialogForm.printerType=='NETC' || this.dialogForm.printerType=='CodeSoft' || this.dialogForm.printerType=='BarTender') {
                this.$set(this.dialogForm, "netcFid", res.fid);
              }
            } else {
              return false;
            }
          } else if ((this.dialogForm.printerType=='NETC' || this.dialogForm.printerType=='CodeSoft' || this.dialogForm.printerType=='BarTender') && this.dialogForm.netcFid<=0) {
            this.$message({
                  type: "warning",
                  message: "模版不能为空！"
                });
            return false;
          }
          if (title == "新建模板" || title == "复制模板") {
            res = await apiLabelTemplateAdd({
              ...this.dialogForm
            });
            // console.log(res);
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              if (title == "新建模板") {
                this.getLabelTemplateSearch();
                this.$message({
                  type: "success",
                  message: "新建成功"
                });
              } else if (title == "复制模板") {
                this.printList.push(res.data);
                this.printLink = res.data.id;
                this.$message({
                  type: "success",
                  message: "复制成功"
                });
              }
            }
          } else if (title == "修改模板") {
            const res = await apiLabelTemplateUpdate({
              ...this.dialogForm
            });
            // console.log(res);
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.$refs.detailPage.getLabelTemplateDetail();
              this.$message({
                type: "success",
                message: "修改成功"
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {
      };      
      this.$refs.fileUpload.value = "";
      this.pullDownData.productList2 = [];
    },
    
    onlyMyChange() {
        this.getLabelTemplateSearch();
    },
    // 清除查询
    onClear() {
      if (this.tabPaneValue == "first") {
        this.searchConditionForm = {};
        this.pullDownData.productList = [];
        this.pagination.currentPage = 1;
        this.getLabelTemplateSearch();
      } else if (this.tabPaneValue == "fontManage") {
        this.fontSearchForm = {};
        this.$refs.fontManage.pagination.currentPage = 1;
        this.$nextTick(() => {
          this.$refs.fontManage.getFontSearch();
        });
      }
    },
    // 确认查询
    onSearch() {
      if (this.tabPaneValue == "first") {
        this.pagination.currentPage = 1;
        this.getLabelTemplateSearch();
      } else if (this.tabPaneValue == "fontManage") {
        this.$refs.fontManage.pagination.currentPage = 1;
        this.$refs.fontManage.getFontSearch();
      }
    },
    // 查询条件-产品类别改变
    productTypeChange(value) {
      this.$set(this.searchConditionForm, "productId", undefined);
      this.pullDownData.productList = [];
      if (value) {
        this.getProductList(value, "productList");
      }
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getLabelTemplateSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getLabelTemplateSearch();
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getLabelTemplateSearch();
    },
    // 表格列组装工单点击
    clickAllowSkip(row) {
      this.printLink = row.id;
      let tabPaneIds = this.printList.map(item => item.id);
      if (tabPaneIds.includes(row.id)) {
        this.printList.splice(tabPaneIds.indexOf(row.id), 1, row);
      } else {
        this.printList.push(row);
      }
    },
    // 产品类别下拉数据
    async getProductTypeList() {
      const res = await apiProductTypeList();
      if (res.code == 0) {
        this.pullDownData.productTypeList = res.data;
      }
    },
    // 产品型号下拉
    async getProductList(productType, name) {
      const res = await apiProductList({
        productType
      });
      if (res.code == 0) {
        this.pullDownData[name] = res.data;
      }
    },
    // 客户名称下拉
    async getCustomerList() {
      const res = await apiCustomerList();
      if (res.code == 0) {
        this.pullDownData.customerList = res.data;
      }
    },
    // 标签类型下拉
    async getLabelTypeList() {
      const res = await apiLabelTypeList();
      if (res.code == 0) {
        this.pullDownData.labelTypeList = res.data;
      }
    },
    // 打印机类型下拉
    async getPrinterTypeList() {
      const res = await apiPrinterTypeList();
      if (res.code == 0) {
        this.pullDownData.printerTypeList = res.data;
      }
    },
    callback() {
      this.getCustomerList();
      this.getProductTypeList();
      this.getLabelTypeList();
      this.getPrinterTypeList();
    }
  },
  activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
    if (this.tabPaneValue == "first") {
      if (this.printLink == "firstLink") {
        this.getLabelTemplateSearch("", this.callback);
      } else {
        this.$nextTick(() => {
          this.$refs.detailPage.getLabelTemplateDetail("", this.callback);
        });
      }
    } else {
      this.$nextTick(() => {
        this.$refs.fontManage.getFontSearch("", this.callback);
      });
    }
  },
  deactivated() {
    window.onresize = null;
  }
};
</script>

<style lang="less" scoped>
.scrollDialog {
  /deep/.el-dialog {
    transform: translateY(0);
    max-height: 96vh;
    display: flex;
    flex-direction: column;
    .el-dialog__body {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      .scrollForm {
        flex: 1;
        overflow: auto;
        margin-bottom: 16px;
        .el-form-item:last-child {
          margin-bottom: 0;
        }
      }
    }

  }
}
.roll_back_btn {
  margin-right:10px;
  border-color: #E4E7ED;
  color: #C0C4CC;
}
.roll_back_btn:hover {
  color: var(--themeColor);
  border-color: var(--themeLightBorder);
  background-color: var(--themeLightBg);
}
</style>